import { useState } from "react";
import { Col, Row } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { LearningFilterTitle } from "../../../../../Constants/Constants";
import Categories from "./Categories";
import FindCourseCard from "./FindCourseCard/FindCourseCard";
import UpcomingCourses from "./UpcomingCourses";

const LearningFilter = () => {
  const [open, setOpen] = useState(false);

  return (
    <Col xl="3" className="xl-40 box-col-12 learning-filter">
      <div className="md-sidebar">
        <Btn onClick={() => setOpen(!open)} color="primary" className="email-aside-toggle md-sidebar-toggle">{LearningFilterTitle}</Btn>
        <div className={`md-sidebar-aside job-sidebar ${open ? "open" : ""}`}>
          <div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
            <Row>
              <FindCourseCard />
              <Categories />
              <UpcomingCourses />
            </Row>
          </div>
        </div>
      </div>
    </Col>
  );
};
export default LearningFilter;
